import { useState } from 'react'
// import { aboveTypes } from './types'

export const useHandlePopup = () => {
  const [layer, setlayer] = useState<boolean>(false)

  //   const [settingsUnblur, setsettingsUnblur] = useState<boolean>(false)
  const [popup, setpopUp] = useState<any>(false)

  const handlePopup = (a: any) => {
    if (!a) {
      setTimeout(() => {
        setpopUp(false)
        setlayer(false)
      }, 50)
    } else {
      setTimeout(() => {
        setlayer(true)
        setpopUp(a)
      }, 50)
    }
    // if (a === 'Bet Reply') {
    //   setsettingsUnblur(true)
    //   setTimeout(() => {
    //     setsettingsUnblur(false)
    //   }, 1000)
    // }
  }
  return [layer, popup, handlePopup]
}
